import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../redux/actions";
import qrIcon from '../../assets/icons/qrCode-white.svg';

const ViewQRbutton = () => {
  const dispatch = useDispatch();
  const origin = useSelector(state => state.origin);
  const session_id = useSelector(state => state.session_id)

  const launchViewer = async () => {
    if(origin === 'shopify' && session_id) window.parent.postMessage('qrModalOpen', '*');
    dispatch(actions.setQRView(true));
  };

  return (
    <div className="ViewQRbutton">
      <button onClick={launchViewer}>
        View In My Space
        <img src={qrIcon} alt="Levar Site"/>
      </button>
    </div>
  );
};

export default ViewQRbutton;
